import { black as a, whiteAlfa as r, red as g, orange as i, green as n, purple as e, graphite as t, graphiteAlfa as c } from "./index3.mjs";
const b = {
  background: a.black950,
  paper: a.black900,
  primary: a.black850,
  secondary: a.black800,
  modal: a.black900,
  modalInverted: a.black50,
  opacity90: c.graphiteAlfa800,
  opacityFixed8: r.whiteAlfa50,
  lightFixed: r.whiteAlfa900,
  accent: e.purple400,
  onAccent: e.purple500,
  accentPale: a.black850,
  success: n.green400,
  warning: i.orange400,
  negative: g.red400
}, o = {
  primary: a.black10,
  primaryInverted: a.black900,
  secondary: a.black400,
  tertiary: a.black600,
  accent: e.purple400,
  success: n.green400,
  warning: i.orange400,
  negative: g.red400,
  lightFixed: a.black10,
  lightFixed70: r.whiteAlfa600,
  darkFixed: t.graphite900,
  onButton: a.black10
}, l = {
  divider: a.black800,
  border: a.black700,
  accent: e.purple400,
  negative: g.red400,
  lightFixed: r.whiteAlfa900,
  lightFixed12: r.whiteAlfa100
}, s = {
  icotexDisable: a.black600,
  accentAction: e.purple500,
  accentPaleAction: a.black800,
  successAction: n.green500,
  warningAction: i.orange500,
  negativeAction: g.red500,
  lightFixedAction: r.whiteAlfa800,
  actionDisabled: a.black800,
  actionPressed: a.black800,
  mainInverted70: a.black900
}, F = {
  brandPrimary: "#193FD6",
  brandSecondary: "#E42CA3",
  brandTertiary: "#DE0056",
  brandQuaternary: "#A8FF00",
  logoPrimary: "#193FD6",
  logoSecondary: "#E42CA3"
}, m = {
  accent: {
    from: "#912AF9",
    to: "#FF46E1",
    css: "linear-gradient(83deg, #912AF9 0%, #FF46E1 100%)"
  },
  accentDark: {
    from: "#2D0B4F",
    to: "#6719B5",
    css: "linear-gradient(63deg, #2D0B4F 0%, #6719B5 98.43%)"
  },
  pulse: {
    from: "#F92A2D",
    to: "#FF4681",
    css: "linear-gradient(83deg, #F92A2D 0%, #FF4681 100%)"
  },
  flow: {
    from: "#05B49B",
    to: "#912AF9",
    css: "linear-gradient(83deg, #05B49B 0%, #912AF9 100%)"
  },
  sunshine: {
    from: "#FF46DA",
    to: "#EEB900",
    css: "linear-gradient(83deg, #FF46DA 0%, #EEB900 100%)"
  },
  depth: {
    from: "#912AF9",
    to: "#FFD166",
    css: "linear-gradient(83deg, #912AF9 0%, #FFD166 100%)"
  },
  muse: {
    from: "#FF46DA",
    to: "#05B49B",
    css: "linear-gradient(83deg, #FF46DA 0%, #05B49B 100%)"
  },
  edge: {
    from: "#3E1D7F",
    to: "#FF46DA",
    css: "linear-gradient(83deg, #3E1D7F 0%, #FF46DA 100%)"
  }
}, A = {
  accent: {
    from: "rgba(200, 56, 237, 0)",
    mid: "rgba(200, 56, 237, 0.4)",
    to: "rgba(200, 56, 237, 1)",
    css: "linear-gradient(180deg, rgba(200, 56, 237, 0) 0%, rgba(200, 56, 237, 0.4) 56%, rgba(200, 56, 237, 1) 100%)"
  },
  accentDark: {
    from: "rgba(74, 18, 130, 0)",
    mid: "rgba(74, 18, 130, 0.4)",
    to: "rgba(74, 18, 130, 1)",
    css: "linear-gradient(180deg, rgba(74, 18, 130, 0) 0%, rgba(74, 18, 130, 0.4) 56%, rgba(74, 18, 130, 1) 100%)"
  },
  pulse: {
    from: "rgba(252, 56, 87, 0)",
    mid: "rgba(252, 56, 87, 0.4)",
    to: "rgba(252, 56, 87, 1)",
    css: "linear-gradient(180deg, rgba(252, 56, 87, 0) 0%, rgba(252, 56, 87, 0.4) 56%, rgba(252, 56, 87, 1) 100%)"
  },
  flow: {
    from: "rgba(75, 111, 202, 0)",
    mid: "rgba(75, 111, 202, 0.4)",
    to: "rgba(75, 111, 202, 1)",
    css: "linear-gradient(180deg, rgba(75, 111, 202, 0) 0%, rgba(75, 111, 202, 0.4) 56%, rgba(75, 111, 202, 1) 100%)"
  },
  sunshine: {
    from: "rgba(222, 94, 48, 0)",
    mid: "rgba(222, 94, 48, 0.4)",
    to: "rgba(222, 94, 48, 1)",
    css: "linear-gradient(180deg, rgba(222, 94, 48, 0) 0%, rgba(222, 94, 48, 0.4) 56%, rgba(222, 94, 48, 1) 100%)"
  },
  depth: {
    from: "rgba(200, 126, 175, 0)",
    mid: "rgba(200, 126, 175, 0.4)",
    to: "rgba(200, 126, 175, 1)",
    css: "linear-gradient(180deg, rgba(200, 126, 175, 0) 0%, rgba(200, 126, 175, 0.4) 56%, rgba(200, 126, 175, 1) 100%)"
  },
  muse: {
    from: "rgba(246, 34, 203, 0)",
    mid: "rgba(246, 34, 203, 0.4)",
    to: "rgba(246, 34, 203, 1)",
    css: "linear-gradient(180deg, rgba(246, 34, 203, 0) 0%, rgba(246, 34, 203, 0.4) 56%, rgba(246, 34, 203, 1) 100%)"
  },
  edge: {
    from: "rgba(158, 50, 172, 0)",
    mid: "rgba(158, 50, 172, 0.4)",
    to: "rgba(158, 50, 172, 1)",
    css: "linear-gradient(180deg, rgba(158, 50, 172, 0) 0%, rgba(158, 50, 172, 0.4) 56%, rgba(158, 50, 172, 1) 100%)"
  }
};
export {
  F as brand,
  m as gradient,
  o as icotext,
  s as interact,
  l as outline,
  A as overlay,
  b as surface
};
